// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f016b69a","389":"42865f76","440":"eb39a21b","455":"080e83f0","672":"25c345ab","977":"d45a1fe8"}[chunkId] + ".chunk.js";
};